module.exports = __webpack_public_path__ + "static/spirit_naga-6f8e1feb55657a5a91a19238e3c8b0ca.jpg";